import styled, { css } from 'styled-components';
import { hideScrollbar } from '@stylesheets/helpers';
import { APPS_PHONE_MEDIA } from '../../apps.constants';

const TILE_PX = 168;
const TILE_PHONE_PX = 150;
const ARROW_CLEARANCE_PX = 48;
const NAME_BAND_PX = 40;

export const ExamplesRoot = styled.section`
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding-top: ${({ theme: { spacing } }) => spacing.level3};
`;

export const ExamplesTitle = styled.h3`
  text-align: center;
  text-transform: uppercase;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.08em;

  ${({ theme: { colors, font, spacing } }) => css`
    margin: ${spacing.level7} 0 ${spacing.level4};
    font-weight: ${font.labelMedium.fontWeight};
    color: ${colors.onSurfaceVariant};
  `}
`;

export const Rail = styled.div`
  position: relative;
  min-width: 0;
`;

export const ArrowSlot = styled.div<{ $side: 'start' | 'end' }>`
  position: absolute;
  top: 50%;
  z-index: 1;
  display: flex;
  border-radius: 50%;
  transform: translateY(-50%);
  ${({ $side }) => ($side === 'start' ? 'left: 4px;' : 'right: 4px;')}

  ${({ theme: { colors } }) => css`
    box-shadow: 0 0 0 1px ${colors.outlineVariant};
  `}
`;

export const Strip = styled.div`
  display: flex;
  justify-content: safe center;
  gap: 12px;
  overflow-x: auto;
  padding: 2px 0;
  scroll-snap-type: x mandatory;
  scroll-padding-inline: ${ARROW_CLEARANCE_PX}px;
  ${hideScrollbar}

  @media (prefers-reduced-motion: no-preference) {
    scroll-behavior: smooth;
  }
`;

export const Tile = styled.button`
  position: relative;
  flex: 0 0 ${TILE_PX}px;
  height: ${TILE_PX}px;
  padding: 0;
  overflow: hidden;
  border-radius: 12px;
  font: inherit;
  text-align: start;
  cursor: pointer;
  scroll-snap-align: start;

  ${({ theme: { colors } }) => css`
    border: 1px solid ${colors.outlineVariant};
    background: ${colors.surfaceContainerHigh};
    color: ${colors.onSurface};

    &:hover:not(:disabled) {
      border-color: ${colors.outline};
    }

    &:focus-visible {
      outline: 2px solid ${colors.primary};
      outline-offset: -2px;
    }
  `}

  &:disabled {
    cursor: progress;
    opacity: 0.6;
  }

  ${APPS_PHONE_MEDIA} {
    flex-basis: ${TILE_PHONE_PX}px;
    height: ${TILE_PHONE_PX}px;
  }
`;

export const TileImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  user-select: none;
`;

export const TileBrief = styled.span`
  position: absolute;
  inset: 0 0 ${NAME_BAND_PX}px;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  padding: 12px 12px 0;
  font-size: 11.5px;
  line-height: 1.4;
  color: ${({ theme: { colors } }) => colors.onSurfaceVariant};
`;

export const TileName = styled.span`
  position: absolute;
  inset: auto 0 0;
  padding: 24px 8px 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;

  ${({ theme: { colors } }) => css`
    color: ${colors.onSurface};
    background: linear-gradient(to top, ${colors.surface} 35%, transparent);
  `}

  ${APPS_PHONE_MEDIA} {
    font-size: 12px;
  }
`;
